import * as Sentry from "@sentry/vue"
import type { App } from "vue"
import type { Router } from "vue-router"
import errorTypeConst from "@common_lib/base/constants/errorTypeConst"

const IS_DEV = import.meta.env.MODE === "dev" || import.meta.env.MODE === "dev-nginx"
const IS_PROD = import.meta.env.MODE === "prod"

const PROD_CUSTOM_CONFIG = {
  sampleRate: 0.005,
  tracesSampleRate: 0,
  maxBreadcrumbs: 10,
  normalizeDepth: 3
}

const UAT_CUSTOM_CONFIG = {
  sampleRate: 1,
  tracesSampleRate: 1,
  maxBreadcrumbs: 100,
  normalizeDepth: 5
}

const CUSTOM_CONFIG = IS_PROD ? PROD_CUSTOM_CONFIG : UAT_CUSTOM_CONFIG

const IGNORE_ERRORS = [
  "error occurred",
  "request canceled",
  "network error",
  "failed to fetch dynamically imported module",
  "Failed to fetch dynamically imported module",
  "unable to preload",
  "locale messages",
  "the play() request", // jbl.js media error
  "AxiosError: Request aborted",
  "AxiosError: Network Error",
  "Importing a module script failed"
]

// 建立排除的錯誤狀態碼列表
const EXCLUDED_ERROR_STATUSES = Object.values(errorTypeConst)
  .filter(errorInfo => errorInfo.excludeFromSentry)
  .map(errorInfo => errorInfo.status)

const DENY_URLS = [/extensions\//i, /^chrome:\/\//i, /jbl\.js/i, "player-min.js"]

const errorCounts = new Map()
const ERROR_THRESHOLD = 5

const initSentry = ({ app, router }: { app: App; router: Router }) => {
  if (IS_DEV) return

  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration({ router })],
    denyUrls: DENY_URLS,
    ignoreErrors: IGNORE_ERRORS,
    beforeSend(event) {
      if (!event.exception?.values) return event

      const errorMessage = event.exception.values[0].value

      if (!errorMessage) return event

      // 檢查是否為需要排除的錯誤狀態碼
      const shouldExclude = EXCLUDED_ERROR_STATUSES.some(
        status => errorMessage.includes(status) || errorMessage.includes(String(status))
      )

      if (shouldExclude) {
        return null
      }

      const count = (errorCounts.get(errorMessage) || 0) + 1
      errorCounts.set(errorMessage, count)

      if (count > ERROR_THRESHOLD) {
        return null
      }

      return event
    },
    ...CUSTOM_CONFIG
  })
}

export default initSentry
